/**
 * Calculates FSMC-score or total filled fields for historyview
 */

import { defaultTo } from 'ramda';
import { getLatestCommitData } from 'lib/documentHandling';
import { calculateFSMCTotal } from 'neuro-calculation-commons';

export const isCompletedFSMC = document => {
  if (safelyHandleValue(document, 'filled') === 20) {
    return true;
  }
  return false;
};

// Calculate total filled fields per document
const calculateFSMCTotals = d => {
  for (let i = 0; i < d.length; i++) {
    d[i] = {
      ...d[i],
      ...calculateFSMCTotal(getLatestCommitData(d[i])),
    };
  }
  return d;
};

const safelyHandleValue = (obj, val) => defaultTo(null, obj[val]);

export default calculateFSMCTotals;
